/*
 * @providesModule AWSConstants
 */

//*************************
//       CORE SDK
//*************************
/** Users taps on the Home tab */
export const HOME_TAB = 'HOME_TAB';
/** Users taps on the Play tab */
export const PLAY_TAB = 'PLAY_TAB';
/** Users taps on the Store tab */
export const STORE_TAB = 'STORE_TAB';
/** Users taps on the Leagues tab */
export const LEAGUES_TAB = 'LEAGUES_TAB';
/** User taps to open the FAQ from the More Menu */
export const MENU_FAQ = 'MENU_FAQ';
/** User taps to open the Tickets/Reward Store from the More Menu  */
export const TICKETZ_VIEW_MENU = 'TICKETZ_VIEW_MENU';
/** User taps to open the Account from the More Menu  */
export const MENU_ACCOUNT = 'MENU_ACCOUNT';
/** User tapped a play tile on the Play tab */
export const PLAY_MATCH_SELECT = 'PLAY_MATCH_SELECT';

//*************************
//          FTUE
//*************************
/** User taps NEXT on account creation to begin the Sync FTUE as determined by game and client properties*/
export const SYNC_FTUE_START = 'SYNC_FTUE_START';
/** User taps NEXT on account creation to begin the Async FTUE as determined by game and client properties*/
export const ASYNC_FTUE_START = 'ASYNC_FTUE_START';
/** User taps NEXT on account creation to begin the Hybrid FTUE as determined by game and client properties*/
export const HYBRID_FTUE_START = 'HYBRID_FTUE_START';
/** User sees the tooltip after their first win explaining what Z is*/
export const FTUE_RESULTS_WIN_Z_TOOLTIP = 'FTUE_RESULTS_WIN_Z_TOOLTIP';
/** User sees the tooltip after their first loss explaining what Ticketz are*/
export const FTUE_RESULTS_LOSE_TICKETZ_TOOLTIP = 'FTUE_RESULTS_LOSE_TICKETZ_TOOLTIP';
/** User sees the tooltip after their first tie explaining how to play their tiebreaker match*/
export const FTUE_RESULTS_TIE_TOOLTIP = 'FTUE_RESULTS_TIE_TOOLTIP';
/** User sees the tooltip prompting to enable pushes after their first pending match*/
export const FTUE_RESULTS_PENDING_PUSHES_DISABLED = 'FTUE_RESULTS_PENDING_PUSHES_DISABLED';
/** User sees the tooltip explaining that we are searching for an opponent after their first pending match*/
export const FTUE_RESULTS_PENDING_PUSHES_ENABLED = 'FTUE_RESULTS_PENDING_PUSHES_ENABLED';
/** User starts their first async match with no opponent during the FTUE*/
export const FTUE_BEGIN_MATCH_NOW_PENDING = 'FTUE_BEGIN_MATCH_NOW_PENDING';
/** User starts their first async match with an opponent during the FTUE*/
export const FTUE_BEGIN_MATCH_NOW_MATCH_FOUND = 'FTUE_BEGIN_MATCH_NOW_MATCH_FOUND';
/** User has loaded the v1 create profile screen */
export const FTUE_CREATE_PROFILE_V1_LOADED = 'FTUE_CREATE_PROFILE_V1_LOADED';
/** User has loaded the v2 create profile screen */
export const FTUE_CREATE_PROFILE_V2_LOADED = 'FTUE_CREATE_PROFILE_V2_LOADED';
/** User taps the sync tournament tile on the play screen during the FTUE*/
export const SYNC_FTUE_TAP_SYNC_TILE_PLAY_SCREEN = 'SYNC_FTUE_TAP_SYNC_TILE_PLAY_SCREEN';
/** User taps the highlighted stakes on the stakes selection screen during the FTUE*/
export const SYNC_FTUE_CHOOSE_STAKES = 'SYNC_FTUE_CHOOSE_STAKES';
/** User taps the PLAY CTA on the stakes selection screen during the FTUE*/
export const SYNC_FTUE_STAKES_SELECTION_PLAY = 'SYNC_FTUE_STAKES_SELECTION_PLAY';
/** User sees the modal on the matchmaking screen prompting them to enable pushes during the FTUE*/
export const SYNC_FTUE_PUSHES_DISABLED_MATCHING_MODAL = 'SYNC_FTUE_PUSHES_DISABLED_MATCHING_MODAL';
/** User sees the modal explaining that we are searching for an opponent during the FTUE*/
export const SYNC_FTUE_PUSHES_ENABLED_MATCHING_MODAL = 'SYNC_FTUE_PUSHES_ENABLED_MATCHING_MODAL';
/** User taps the PLAY CTA on the match found screen during the FTUE*/
export const SYNC_FTUE_MATCH_FOUND_PLAY = 'SYNC_FTUE_MATCH_FOUND_PLAY';
/** User taps through the tooltip explaining their match history during the FTUE*/
export const SYNC_FTUE_MATCH_HISTORY_TOOLTIP = 'SYNC_FTUE_MATCH_HISTORY_TOOLTIP';
/** User taps the PLAY icon on the match select during the FTUE*/
export const SYNC_FTUE_MATCH_HISTORY_PLAY_BUTTON = 'SYNC_FTUE_MATCH_HISTORY_PLAY_BUTTON';
/** User taps the bot avatar during the FTUE*/
export const SYNC_FTUE_BOT_AVATAR_ICON = 'SYNC_FTUE_BOT_AVATAR_ICON';
/** User sees the first part of the FTUE tutorial */
export const SKILLZ_INTRO_BEGIN_FIRST_MATCH = 'SKILLZ_INTRO_BEGIN_FIRST_MATCH';
/** User sees the second part of the FTUE tutorial */
export const SKILLZ_INTRO_BEGIN_SECOND_MATCH = 'SKILLZ_INTRO_BEGIN_SECOND_MATCH';

/** User refreshes their username */
export const FTUE_REFRESH_USERNAME = 'FTUE_REFRESH_USERNAME';
/** User refreshes their profile picture */
export const FTUE_REFRESH_AVATAR = 'FTUE_REFRESH_AVATAR';
/** User taps to enter the match code FTUE */
export const FTUE_MATCH_CODE_TAP_HERE = 'FTUE_MATCH_CODE_TAP_HERE';

/**
 * User reaches the results screen of game X out of N of the sync ftue as determined by the client property sync.ftue.n.forced.games
 * @param a_result string representing how many games (X) out of N have been completed (format: “X/N”)
 */
export const SYNC_FTUE_NTH_MATCH_COMPLETE = 'SYNC_FTUE_NTH_MATCH_COMPLETE';
/**
 * User reaches the results screen of game X out of N of the hybrid ftue as determined by the client property sync.ftue.n.forced.games
 * @param a_result string representing how many games (X) out of N have been completed (format: “X/N”)
 */
export const HYBRID_FTUE_NTH_MATCH_COMPLETE = 'HYBRID_FTUE_NTH_MATCH_COMPLETE';
/** User completes the FastMatch tutorial by entering the queue for the first time during the Sync FTUE*/
export const SYNC_FTUE_FASTMATCH_TUTORIAL_COMPLETE = 'SYNC_FTUE_FASTMATCH_TUTORIAL_COMPLETE';
/** User completes the FastMatch tutorial by entering the queue for the first time during the Hybrid FTUE*/
export const HYBRID_FTUE_FASTMATCH_TUTORIAL_COMPLETE = 'HYBRID_FTUE_FASTMATCH_TUTORIAL_COMPLETE';
/** Play taps “Sign In” on the FTUE slideshow */
export const FTUE_SLIDESHOW_SIGN_IN = 'FTUE_SLIDESHOW_SIGN_IN';
/** Player taps “Play Now” on the FTUE slideshow */
export const FTUE_SLIDESHOW_PLAY_NOW = 'FTUE_SLIDESHOW_PLAY_NOW';
/** Player taps “Enter Match Code” on the FTUE slideshow */
export const FTUE_SLIDESHOW_ENTER_MATCH_CODE = 'FTUE_SLIDESHOW_ENTER_MATCH_CODE';
/** Player views the first slide in the FTUE slideshow */
export const FTUE_SLIDESHOW_VIEW_SLIDE_ONE = 'FTUE_SLIDESHOW_VIEW_SLIDE_ONE';
/** Payer views the second slide in the FTUE slideshow */
export const FTUE_SLIDESHOW_VIEW_SLIDE_TWO = 'FTUE_SLIDESHOW_VIEW_SLIDE_TWO';
/** Payer views the second slide in the FTUE slideshow */
export const FTUE_SLIDESHOW_VIEW_SLIDE_THREE = 'FTUE_SLIDESHOW_VIEW_SLIDE_THREE';
/** Payer views the second slide in the FTUE slideshow */
export const FTUE_SLIDESHOW_VIEW_SLIDE_FOUR = 'FTUE_SLIDESHOW_VIEW_SLIDE_FOUR';
/** User has completed the Home tab tutorial */
export const SKILLZ_INTRO_COMPLETE_MATCH_STREAM = 'SKILLZ_INTRO_COMPLETE_MATCH_STREAM';
/** User has seen the Store tutorial */
export const FTUE_STORE_VIEW = 'FTUE_STORE_VIEW';
/** User has seen the Progressive Leagues tutorial */
export const FTUE_PROGRESSIVE_LEAGUES_VIEW = 'FTUE_PROGRESSIVE_LEAGUES_VIEW';
/** User has seen the Trophies tutorial */
export const FTUE_TROPHIES_VIEW = 'FTUE_TROPHIES_VIEW';
/** User has seen the Play Again tutorial and clicked YES */
export const FTUE_PLAY_AGAIN_CLICK_YES = 'FTUE_PLAY_AGAIN_CLICK_YES';
/** User has seen the Play Again tutorial and clicked NO */
export const FTUE_PLAY_AGAIN_CLICK_NO = 'FTUE_PLAY_AGAIN_CLICK_NO';
/** User has seen the Interstitial tutorial */
export const FTUE_INTERSTITIALS_VIEW = 'FTUE_INTERSTITIALS_VIEW';
/** User has seen the Brackets tutorial */
export const FTUE_BRACKETS_VIEW = 'FTUE_BRACKETS_VIEW';
/** User has seen the Levels tutorial */
export const FTUE_LEVELS_VIEW = 'FTUE_LEVELS_VIEW';

//*************************
//        LOYALTY
//*************************
/** when player taps on a ‘skillz reward’ in store page entry point */
export const LOYALTY_STORE_ENTRY_POINT_SKLLZ_REWARD_TAPPED =
  'LOYALTY_STORE_ENTRY_POINT_SKLLZ_REWARD_TAPPED';
/** when player taps on a specific item in store page entry point
 * @param a_result string representing item sku */
export const LOYALTY_STORE_ENTRY_POINT_ITEM_TAPPED = 'LOYALTY_STORE_ENTRY_POINT_ITEM_TAPPED';
/** when the ‘How it Works’ section appears on after player taps tier detail text
 * @param a_result string for the name of user's current tier */
export const LOYALTY_TIER_DETAIL_EXPAND_TAPPED = 'LOYALTY_TIER_DETAIL_EXPAND_TAPPED';
/** when loyalty store is viewed
 * @param a_result string for the name of user's current tier */
export const LOYALTY_STORE_VIEW = 'LOYALTY_STORE_VIEW';
/** when player taps ‘see more’ on loyalty store
 * @param a_result string representing the name of the category tapped */
export const LOYALTY_STORE_SEE_MORE_TAPPED = 'LOYALTY_STORE_SEE_MORE_TAPPED';
/** when player taps on an item on loyalty store, send all item attributes as well (e.g. name, description, cost...)
 * @param a_result string representing item sku */
export const LOYALTY_STORE_ITEM_TAPPED = 'LOYALTY_STORE_ITEM_TAPPED';
/** when item detail page is viewed
 * @param a_result string representing item sku */
export const LOYALTY_STORE_ITEM_DETAIL_VIEW = 'LOYALTY_STORE_ITEM_DETAIL_VIEW';
/** when player taps ‘redeem’ on item detail page
 * @param a_result string representing item's sku, using the variant sku if applicable */
export const LOYALTY_STORE_ITEM_DETAIL_REDEEM_TAPPED = 'LOYALTY_STORE_ITEM_DETAIL_REDEEM_TAPPED';
/** when not enough ticketz modal is viewed */
export const LOYALTY_STORE_ITEM_DETAIL_NOT_ENOUGH_TICKETZ_VIEW =
  'LOYALTY_STORE_ITEM_DETAIL_NOT_ENOUGH_TICKETZ_VIEW';
/** when add address page is viewed */
export const LOYALTY_STORE_ADD_ADDRESS_VIEW = 'LOYALTY_STORE_ADD_ADDRESS_VIEW';
/** when player taps ‘next’ on add address page */
export const LOYALTY_STORE_ADD_ADDRESS_SUBMITTED = 'LOYALTY_STORE_ADD_ADDRESS_SUBMITTED';
/** when order summary page is viewed
 * @param a_result string representing item's sku, using the variant sku if applicable */
export const LOYALTY_STORE_ORDER_SUMMARY_VIEW = 'LOYALTY_STORE_ORDER_SUMMARY_VIEW';
/** when player taps next on order summary page
 * @param a_result string representing item's sku, using the variant sku if applicable */
export const LOYALTY_STORE_ORDER_SUMMARY_SUBMITTED = 'LOYALTY_STORE_ORDER_SUMMARY_SUBMITTED';
/** when order success page is loaded
 * @param a_result string representing item's sku, using the variant sku if applicable */
export const LOYALTY_STORE_ORDER_SUCCESS_MODAL_VIEW = 'LOYALTY_STORE_ORDER_SUCCESS_MODAL_VIEW';

//*************************************
//  HOSTED TOURNAMENT (LIVE EVENTS)
//*************************************
/** when user manually goes to the prize tab */
export const HOSTED_LIVE_EVENTS_PRIZES = 'HOSTED_LIVE_EVENTS_PRIZES';
/** when user manually goes to the leaderboard tab */
export const HOSTED_LIVE_EVENTS_LEADERBOARD = 'HOSTED_LIVE_EVENTS_LEADERBOARD';
/** when user manually goes to the rules tab */
export const HOSTED_LIVE_EVENTS_RULES = 'HOSTED_LIVE_EVENTS_RULES';
/** when user view the prizes tab content */
export const HOSTED_LIVE_EVENTS_PRIZES_VIEW = 'HOSTED_LIVE_EVENTS_PRIZES_VIEW';
/** when user view the leaderboard tab content */
export const HOSTED_LIVE_EVENTS_LEADERBOARD_VIEW = 'HOSTED_LIVE_EVENTS_LEADERBOARD_VIEW';
/** when user view the rules tab content */
export const HOSTED_LIVE_EVENTS_RULES_VIEW = 'HOSTED_LIVE_EVENTS_RULES_VIEW';
/** when user view the transition modal from free to paid entries for a live event */
export const HOSTED_LIVE_EVENTS_TRANSITION_MODAL = 'HOSTED_LIVE_EVENTS_TRANSITION_MODAL';
/** when user taps to share on event details screen */
export const HOSTED_LIVE_EVENTS_SHARE = 'HOSTED_LIVE_EVENTS_SHARE';
/** when user taps Next button on event details screen */
export const HOSTED_LIVE_EVENTS_NEXT = 'HOSTED_LIVE_EVENTS_NEXT';
/** when user taps Play button on event details screen */
export const HOSTED_LIVE_EVENTS_PLAY = 'HOSTED_LIVE_EVENTS_PLAY';
/** when user taps Play button to play again on event details screen */
export const HOSTED_LIVE_EVENTS_PLAY_AGAIN = 'HOSTED_LIVE_EVENTS_PLAY_AGAIN';

//*************************************
//  Limited Time Offer
//*************************************
/** User taps Limited Time Offer button on the Play Tab */
export const LTO_CLICK_PLAY = 'LTO_CLICK_PLAY';
/** User taps Limited Time Offer button on the Store Tab */
export const LTO_CLICK_STORE = 'LTO_CLICK_STORE';

//*************************************
//  Store Tab Deposit Offer
//*************************************
/** User taps Deposit Tile on the Store Tab */
export const DEPOSIT_TAP_STORE = 'DEPOSIT_TAP_STORE';
/** User taps Deposit Tile on the Insufficient Funds Modal */
export const DEPOSIT_TAP_INSUFFICIENT_FUND_MODAL = 'DEPOSIT_TAP_INSUFFICIENT_FUND_MODAL';

//*************************************
//  Progression Room
//*************************************
/** User taps the match stream entry point for progression */
export const PROGRESSION_ROOM_MATCH_STREAM_TAP = 'PROGRESSION_ROOM_MATCH_STREAM_TAP';
/** User taps the side menu (hamburger) entry point for progression */
export const PROGRESSION_ROOM_SIDE_MENU_TAP = 'PROGRESSION_ROOM_SIDE_MENU_TAP';

//*************************************
//  AUTHENTICATION
//*************************************
/** Triggered on successful sign-in from account menu screen when user was not already logged in on a saved account */
export const SIGN_IN_SWITCH_ACCOUNT_SUCCESS = 'SIGN_IN_SWITCH_ACCOUNT_SUCCESS';
/** Triggered on successful sign-in from account menu screen when user was already logged in on a saved account */
export const SIGN_IN_MY_ACCOUNT_SUCCESS = 'SIGN_IN_MY_ACCOUNT_SUCCESS';
/** Triggered on saving an account with an email */
export const SIGN_UP_EMAIL_CLICK = 'SIGN_UP_EMAIL_CLICK';
/** Triggered when trying to save a new account with an email already in use */
export const SIGN_UP_EMAIL_EXISTING_ACCOUNT = 'SIGN_UP_EMAIL_EXISTING_ACCOUNT';
/** Triggered when trying to save a new account with an email results in an error */
export const SIGN_UP_EMAIL_ERROR = 'SIGN_UP_EMAIL_ERROR';
/** Triggered when user clicks 'forgot password' */
export const FORGOT_PASSWORD_SUBMIT_CLICK = 'FORGOT_PASSWORD_SUBMIT_CLICK';
/** Triggered when there is an error in the forgot password flow */
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
/** Triggered when user chooses to sign in with email */
export const SIGN_IN_EMAIL_CLICK = 'SIGN_IN_EMAIL_CLICK';
/** Triggered when a user tries and fails to sign in through a Google account */
export const SIGN_IN_GOOGLE_ERROR = 'SIGN_IN_GOOGLE_ERROR';
/** Triggered when user chooses to sign in with a Google account */
export const SIGN_IN_GOOGLE_CLICK = 'SIGN_IN_GOOGLE_CLICK';
/** Triggered when trying to save a new account with a Google account already in use */
export const SIGN_UP_GOOGLE_EXISTING_ACCOUNT = 'SIGN_UP_GOOGLE_EXISTING_ACCOUNT';
/** Triggered when trying to save a new account with a Google account results in an error */
export const SIGN_UP_GOOGLE_ERROR = 'SIGN_UP_GOOGLE_ERROR';
/** Triggered on saving an account through a Google account */
export const SIGN_UP_GOOGLE_CLICK = 'SIGN_UP_GOOGLE_CLICK';
/** Triggered when a user tries and fails to sign in through an Apple account */
export const SIGN_IN_APPLE_ERROR = 'SIGN_IN_APPLE_ERROR';
/** Triggered when user chooses to sign in with an Apple account */
export const SIGN_IN_APPLE_CLICK = 'SIGN_IN_APPLE_CLICK';
/** Triggered when trying to save a new account with an Apple account already in use */
export const SIGN_UP_APPLE_EXISTING_ACCOUNT = 'SIGN_UP_APPLE_EXISTING_ACCOUNT';
/** Triggered when trying to save a new account with an Apple account results in an error */
export const SIGN_UP_APPLE_ERROR = 'SIGN_UP_APPLE_ERROR';
/** Triggered on saving an account through an Apple account */
export const SIGN_UP_APPLE_CLICK = 'SIGN_UP_APPLE_CLICK';
/** Triggered when a user tries and fails to sign in through a Facebook account */
export const SIGN_IN_FACEBOOK_ERROR = 'SIGN_IN_FACEBOOK_ERROR';
/** Triggered when user chooses to sign in with a Facebook account */
export const SIGN_IN_FACEBOOK_CLICK = 'SIGN_IN_FACEBOOK_CLICK';
/** Triggered when trying to save a new account with a Facebook account already in use */
export const SIGN_UP_FACEBOOK_EXISTING_ACCOUNT = 'SIGN_UP_FACEBOOK_EXISTING_ACCOUNT';
/** Triggered when trying to save a new account with a Facebook account results in an error */
export const SIGN_UP_FACEBOOK_ERROR = 'SIGN_UP_FACEBOOK_ERROR';
/** Triggered on saving an account through a Facebook account */
export const SIGN_UP_FACEBOOK_CLICK = 'SIGN_UP_FACEBOOK_CLICK';
/** Triggered on successful sign-in */
export const SIGN_IN_USER_SUCCESS = 'SIGN_IN_USER_SUCCESS';
/** Triggered on taking user information */
export const SIGN_UP_SUBSCRIBE_NEWSLETTERS = 'SIGN_UP_SUBSCRIBE_NEWSLETTERS';

/** Triggered when the 'Next' button from profile screen is pressed */
export const CREATE_PROFILE_NEXT_PRESSED = 'CREATE_PROFILE_NEXT_PRESSED';
/** Triggered when the 'Sign In' button from profile screen is pressed */
export const CREATE_PROFILE_SIGN_IN_PRESSED = 'CREATE_PROFILE_SIGN_IN_PRESSED';

//*************************************
//  MISC
//*************************************
/** Triggered on failed POST request to the API /ps/v1/track/push , which is used to track push notifications that have been interacted with by the user */
export const PUSH_NOTIFICATION_TRACKING_FAILED_REQUEST =
  'PUSH_NOTIFICATION_TRACKING_FAILED_REQUEST';

//************************************
// HOSTED TOUNAMENT TAKE OVER
// For each event, include the live event ID as an additional attribute under “result”
//************************************
/** User views the full page takeover for Hosted as part of the Welcome Back flow */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_VIEW = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_VIEW';
/** User taps “Share” when viewing the full page takeover for Hosted as part of the Welcome Back flow */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_SHARE = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_SHARE';
/** User taps “Results” when viewing the full page takeover for Hosted as part of the Welcome Back flow */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_RESULTS = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_RESULTS';
/** User taps “Next” when viewing the full page takeover for Hosted as part of the Welcome Back flow */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_NEXT = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_NEXT';
/** User views the full page takeover for Hosted from the Home tab */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_VIEW = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_VIEW';
/** User taps “Back” when viewing the full page takeover for Hosted from the Home tab */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_BACK = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_BACK';
/** User taps “Results” when viewing the full page takeover for Hosted from the Home tab */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_RESULTS =
  'HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_RESULTS';
/** User taps “Share” when viewing the full page takeover for Hosted from the Home tab */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_SHARE =
  'HOSTED_LIVE_EVENTS_WELCOMEBACK_HOME_SHARE';
/** User taps a link in the text field of a Hosted Tournament full page over */
export const HOSTED_LIVE_EVENTS_WELCOMEBACK_LINK = 'HOSTED_LIVE_EVENTS_WELCOMEBACK_LINK';

//************************************
//  REWARD CALENDAR
//************************************
/** User taps the i button on Reward Calendar Modal */
export const DAILY_REWARD_CALENDAR_INFO = 'DAILY_REWARD_CALENDAR_INFO';
/** User taps the claimable cell from Reward Calendar Modal */
export const DAILY_REWARD_CALENDAR_CLAIM = 'DAILY_REWARD_CALENDAR_CLAIM';
/** User enters the Reward Calendar Modal */
export const DAILY_REWARD_CALENDAR_STORE_ENTRY = 'DAILY_REWARD_CALENDAR_STORE_ENTRY';
/** User claims the last cell from the Reward Calendar Modal */
export const DAILY_REWARD_CALENDAR_COMPLETED = 'DAILY_REWARD_CALENDAR_COMPLETED';

//************************************
// WELCOME BACK OVERLAY
//************************************
/** Welcome Back Overlay is displayed */
export const WELCOME_BACK_OVERLAY_DISPLAY = 'WELCOME_BACK_OVERLAY_DISPLAY';
/** "The “Close” CTA on the Welcome Back Overlay is tapped */
export const WELCOME_BACK_OVERLAY_CLOSE = 'WELCOME_BACK_OVERLAY_CLOSE';
/** The “Jump to Bottom” CTA is tapped on the Welcome Back overlay */
export const WELCOME_BACK_OVERLAY_JUMP = 'WELCOME_BACK_OVERLAY_JUMP';

//************************************
// LEAGUE 3.0
//************************************
/** User views the league subtab x,y,z */
export const SEGMENTED_LEAGUE_LEADERBOARD_SUBTAB_VIEW = 'SEGMENTED_LEAGUE_LEADERBOARD_SUBTAB_VIEW';
/** User taps on play button from the league leaderboard */
export const SEGMENTED_LEAGUE_LEADERBOARD_PLAY_BUTTON = 'SEGMENTED_LEAGUE_LEADERBOARD_PLAY_BUTTON';
/** User taps on play modal from the general screen or progression screen */
export const SEGMENTED_LEAGUE_PLAY_BUTTON = 'SEGMENTED_LEAGUE_PLAY_BUTTON';
/** User taps on prize image from league leaderboard */
export const SEGMENTED_LEAGUE_PRIZE_DETAILS_VIEW = 'SEGMENTED_LEAGUE_PRIZE_DETAILS_VIEW';
/** User taps or swipes on prize carousel */
export const SEGMENTED_LEAGUE_PRIZE_DETAILS_SWIPE = 'SEGMENTED_LEAGUE_PRIZE_DETAILS_SWIPE';
/** User swipes on league leaderboard header carousel */
export const SEGMENTED_LEAGUE_HEADER_CAROUSEL_SWIPE = 'SEGMENTED_LEAGUE_HEADER_CAROUSEL_SWIPE';
/** User views Welcome Screen FTUE modal */
export const SEGMENTED_LEAGUE_FTUE_LEAGUE_MODAL_VIEW = 'SEGMENTED_LEAGUE_FTUE_LEAGUE_MODAL_VIEW';
/** User taps on next or swipes on Welcome Screen FTUE modal */
export const SEGMENTED_LEAGUE_FTUE_LEAGUE_MODAL_SWIPE = 'SEGMENTED_LEAGUE_FTUE_LEAGUE_MODAL_SWIPE';
/** User views RESULTS modal for league x, y, z */
export const SEGMENTED_LEAGUE_RESULTS_MODAL_VIEW = 'SEGMENTED_LEAGUE_RESULTS_MODAL_VIEW';
/** User taps on next on RESULTS modal for league x, y, z */
export const SEGMENTED_LEAGUE_RESULTS_MODAL_NEXT = 'SEGMENTED_LEAGUE_RESULTS_MODAL_NEXT';
/** User taps on skip on RESULTS modal for league x, y, z */
export const SEGMENTED_LEAGUE_RESULTS_MODAL_SKIP = 'SEGMENTED_LEAGUE_RESULTS_MODAL_SKIP';
/** User taps on share on RESULTS modal for league x, y, z */
export const SEGMENTED_LEAGUE_RESULTS_MODAL_SHARE = 'SEGMENTED_LEAGUE_RESULTS_MODAL_SHARE';
/** User views qualification  modal for league x, y, z */
export const SEGMENTED_LEAGUE_QUALIFICATION_MODAL_VIEW =
  'SEGMENTED_LEAGUE_QUALIFICATION_MODAL_VIEW';
/** User taps next on qualification  modal for league x, y, z */
export const SEGMENTED_LEAGUE_QUALIFICATION_MODAL_NEXT =
  'SEGMENTED_LEAGUE_QUALIFICATION_MODAL_NEXT';
/** User taps on skip on RESULTS modal for league x, y, z */
export const SEGMENTED_LEAGUE_QUALIFICATION_MODAL_SKIP =
  'SEGMENTED_LEAGUE_QUALIFICATION_MODAL_SKIP';
/** User taps "Share" when viewing league prize screen */
export const SEGMENTED_LEAGUE_PRIZE_SHARE = 'SEGMENTED_LEAGUE_PRIZE_SHARE';
/** User taps "Share" when viewing league Podium results screen */
export const SEGMENTED_LEAGUE_PODIUM_SHARE = 'SEGMENTED_LEAGUE_PODIUM_SHARE';
/** User taps “Share” when viewing league qualfication screen */
export const SEGMENTED_LEAGUE_QUALIFICATION_SHARE = 'SEGMENTED_LEAGUE_QUALIFICATION_SHARE';

//************************************
// MATCH
//************************************
/** User taps the "Begin Match Now" button on the Versus Screen */
export const MATCH_SELECT_BEGIN_MATCH_NOW = 'MATCH_SELECT_BEGIN_MATCH_NOW';
/** Match begins but already has a transaction ID */
export const VERSUS_MATCH_JOIN_POSSIBLY_DUPED = 'VERSUS_MATCH_JOIN_POSSIBLY_DUPED';
/** User presses the versus back button or Android back button on Versus Screen */
export const VS_BACK = 'VS_BACK';
/** SDK fails attempt to pass control to developer and needs to retry */
export const VERSUS_MATCH_JOIN_PASS_CONTROL_BAD_MATCH_RETRYING =
  'VERSUS_MATCH_JOIN_PASS_CONTROL_BAD_MATCH_RETRYING';
/** SDK fails retry to pass control to developer */
export const VERSUS_MATCH_JOIN_PASS_CONTROL_BAD_MATCH_RETRY_FAIL =
  'VERSUS_MATCH_JOIN_PASS_CONTROL_BAD_MATCH_RETRY_FAIL';
/** User displays the match details */
export const MATCH_SELECT_MATCH_DETAILS = 'MATCH_SELECT_MATCH_DETAILS';
/** Used to track elapsed time to fetch data prior to load versus screen */
export const TIME_TO_FETCH_VERSUS_DATA_MS = 'TIME_TO_FETCH_VERSUS_DATA_MS';
export const SDK_DISPLAYED_ERROR = 'SDK_DISPLAYED_ERROR';
/** Used when a match ends for a user */
export const MATCH_END_RESULT = 'MATCH_END_RESULT';
/** Used to track when a match join is initiated */
export const TIME_TO_JOIN_MATCH = 'TIME_TO_JOIN_MATCH';

//************************************
// LEAGUE 3.1
//************************************
/** User views league info screen error modal */
export const SEGMENTED_LEAGUE_INFO_SCREEN_VIEW_ERROR = 'SEGMENTED_LEAGUE_INFO_SCREEN_VIEW_ERROR';
/** User taps “ok” on league info screen error modal */
export const SEGMENTED_LEAGUE_INFO_SCREEN_TAP_ERROR = 'SEGMENTED_LEAGUE_INFO_SCREEN_TAP_ERROR';
/** User views league leaderboard player error modal */
export const SEGMENTED_LEAGUE_LEADERBOARD_PLAYER_VIEW_ERROR =
  'SEGMENTED_LEAGUE_LEADERBOARD_PLAYER_VIEW_ERROR';
/** User taps “ok” on league leaderboard player error modal */
export const SEGMENTED_LEAGUE_LEADERBOARD_PLAYER_TAP_ERROR =
  'SEGMENTED_LEAGUE_LEADERBOARD_PLAYER_TAP_ERROR';
/** User views league results screen view error modal */
export const SEGMENTED_LEAGUE_RESULTS_SCREEN_VIEW_ERROR =
  'SEGMENTED_LEAGUE_RESULTS_SCREEN_VIEW_ERROR';
/** User taps “ok” on league results screen error modal  */
export const SEGMENTED_LEAGUE_RESULTS_SCREEN_TAP_ERROR =
  'SEGMENTED_LEAGUE_RESULTS_SCREEN_TAP_ERROR';
/** User taps “Share AND REDEEM” when viewing share screen */
export const SEGMENTED_LEAGUE_SHARE_REDEEM = 'SEGMENTED_LEAGUE_SHARE_REDEEM';
/** User taps “Share” CTA icon when viewing league prize screen */
export const SEGMENTED_LEAGUE_PRIZE_SHARE_ICON = 'SEGMENTED_LEAGUE_PRIZE_SHARE_ICON';
/** User taps “Share” CTA icon when viewing league podium results screen */
export const SEGMENTED_LEAGUE_PODIUM_SHARE_ICON = 'SEGMENTED_LEAGUE_PODIUM_SHARE_ICON';
/** User taps “Share” CTA icon when viewing league qualification screen */
export const SEGMENTED_LEAGUE_QUALIFICATION_SHARE_ICON =
  'SEGMENTED_LEAGUE_QUALIFICATION_SHARE_ICON';
/** User views league tab screen error modal */
export const SEGMENTED_LEAGUE_TAB_VIEW_ERROR = 'SEGMENTED_LEAGUE_TAB_VIEW_ERROR';
/** User taps “ok” on league tab screen error modal */
export const SEGMENTED_LEAGUE_TAB_TAP_ERROR = 'SEGMENTED_LEAGUE_TAB_TAP_ERROR';
/** User views league tab unavailable view error modal */
export const SEGMENTED_LEAGUE_TAB_UNAVAIL_VIEW_ERROR = 'SEGMENTED_LEAGUE_TAB_UNAVAIL_VIEW_ERROR';
/** User taps “ok on league tab unavailable error modal */
export const SEGMENTED_LEAGUE_TAB_UNAVAIL_ERROR = 'SEGMENTED_LEAGUE_TAB_UNAVAIL_ERROR';
/** User views league tab under construction view modal */
export const SEGMENTED_LEAGUES_UNDER_CONSTRUCTION_MODAL =
  'SEGMENTED_LEAGUES_UNDER_CONSTRUCTION_MODAL';

//************************************
// LEAGUE 3.1 - PROGRESSIVE LEAGUE
//************************************
/** User view the progressive league info modal  */
export const PROGRESSIVE_LEAGUE_INFO_MODAL = 'PROGRESSIVE_LEAGUE_INFO_MODAL';
/** User view the progressive league screen */
export const PROGRESSIVE_LEAGUE_SCREEN_LOAD = 'PROGRESSIVE_LEAGUE_SCREEN_LOAD';
/** User views the Instant Promotion interstitial screen */
export const LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_VIEW =
  'LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_VIEW';
/** User taps “Play Again" on the Instant Promotion interstitial screen */
export const LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_PLAY_AGAIN =
  'LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_PLAY_AGAIN';
/** User taps "Next" on the Instant Promotion interstitial screen */
export const LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_NEXT =
  'LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_NEXT';
/** User taps the "X" close button on the Instant Promotion interstitial screen */
export const LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_CLOSE =
  'LEAGUES_INTERSTITIAL_INSTPROMO_SCREEN_CLOSE';
/** User views the Status interstitial screen */
export const LEAGUES_INTERSTITIAL_STATUS_SCREEN_VIEW = 'LEAGUES_INTERSTITIAL_STATUS_SCREEN_VIEW';
/** User taps “Play Again" on the Status interstitial screen */
export const LEAGUES_INTERSTITIAL_STATUS_SCREEN_PLAY_AGAIN =
  'LEAGUES_INTERSTITIAL_STATUS_SCREEN_PLAY_AGAIN';
/** User taps "Next" on the Status interstitial screen */
export const LEAGUES_INTERSTITIAL_STATUS_SCREEN_NEXT = 'LEAGUES_INTERSTITIAL_STATUS_SCREEN_NEXT';
/** User taps the "X" close button on the Status interstitial screen */
export const LEAGUES_INTERSTITIAL_STATUS_SCREEN_CLOSE = 'LEAGUES_INTERSTITIAL_STATUS_SCREEN_CLOSE';
/** User views the Leagues conclude/results screen  modal */
export const LEAGUES_CONCLUDE_SCREEN_VIEW = 'LEAGUES_CONCLUDE_SCREEN_VIEW';
/** User taps "Claim" on the Leagues conclude/results screen  modal */
export const LEAGUES_CONCLUDE_SCREEN_CLICK_CLAIM = 'LEAGUES_CONCLUDE_SCREEN_CLICK_CLAIM';
/** User taps "Claim/Play" on the Leagues conclude/results screen  modal */
export const LEAGUES_CONCLUDE_SCREEN_CLAIM_PRESS = 'LEAGUES_CONCLUDE_SCREEN_CLAIM_PRESS';
/** User taps the opt-in button in the top corner of the leagues screen */
export const PAID_LEAGUE_OPT_IN_BTN_PRESS = 'PAID_LEAGUE_OPT_IN_BTN_PRESS';
/** User views the league service fee opt-in modal */
export const PAID_LEAGUE_OPT_IN_MODAL_SHOWN_AUTOMATIC = 'PAID_LEAGUE_OPT_IN_MODAL_SHOWN_AUTOMATIC';
/** User taps 'Join' on the league service fee opt-in modal */
export const PAID_LEAGUE_OPT_IN_MODAL_JOIN_PRESS = 'PAID_LEAGUE_OPT_IN_MODAL_JOIN_PRESS';
/** User dismisses the league service fee opt-in modal */
export const PAID_LEAGUE_OPT_IN_MODAL_DISMISSED = 'PAID_LEAGUE_OPT_IN_MODAL_DISMISSED';
/** User taps 'Join' on the sticky footer cell on the leagues screen */
export const PAID_LEAGUE_OPT_IN_FOOTER_JOIN_PRESS = 'PAID_LEAGUE_OPT_IN_FOOTER_JOIN_PRESS';
/** User taps the opt-out button in the top corner of the leagues screen */
export const PAID_LEAGUE_OPT_OUT_BTN_PRESS = 'PAID_LEAGUE_OPT_OUT_BTN_PRESS';
/** User taps 'Exit League' on the first opt-out modal */
export const PAID_LEAGUE_OPT_OUT_MODAL_1_EXIT_PRESS = 'PAID_LEAGUE_OPT_OUT_MODAL_1_EXIT_PRESS';
/** User dismisses the first opt-out modal */
export const PAID_LEAGUE_OPT_OUT_MODAL_1_DISMISS = 'PAID_LEAGUE_OPT_OUT_MODAL_1_DISMISS';
/** User taps 'Exit League' on the second opt-out modal */
export const PAID_LEAGUE_OPT_OUT_MODAL_2_EXIT_PRESS = 'PAID_LEAGUE_OPT_OUT_MODAL_2_EXIT_PRESS';
/** User dismisses the second opt-out modal */
export const PAID_LEAGUE_OPT_OUT_MODAL_2_DISMISS = 'PAID_LEAGUE_OPT_OUT_MODAL_2_DISMISS';
/** User views the paid leagues indicator on the leagues footer icon */
export const LEAGUES_TAB_PAID_LEAGUE_INDICATOR_SHOWN = 'LEAGUES_TAB_PAID_LEAGUE_INDICATOR_SHOWN';
/** Global League FAQ Shown */
export const GLOBAL_LEAGUES_FAQ_SHOWN = 'GLOBAL_LEAGUES_FAQ_SHOWN';
/** Global League Info Modal Screen Shown */
export const GLOBAL_LEAGUES_INFO_MODAL_SCREEN_LOADED = 'GLOBAL_LEAGUES_INFO_MODAL_SCREEN_LOADED';
/** User views the medal breakdown modal */
export const LEAGUES_MEDAL_BREAKDOWN_VIEW = 'LEAGUES_MEDAL_BREAKDOWN_VIEW';
/** User taps on the player icon in the medal breakdown modal to see PlayerDetailModal */
export const LEAGUES_MEDAL_BREAKDOWN_PLAYER_ICON_PRESS =
  'LEAGUES_MEDAL_BREAKDOWN_PLAYER_ICON_PRESS';

//************************************
// LEAGUE 3.2 - PROGRESSIVE LEAGUES V2 (Global Leagues MS2 & beyond)
//************************************

/** User views the paid league footer info (not in paid league) */
export const PAID_LEAGUE_VIEW_FOOTER_INFO = 'PAID_LEAGUE_VIEW_FOOTER_INFO';
/** User views a specific league in Progressive Leagues V2 */
export const PROG_LEAGUES_V2_LEAGUE_VIEW = 'PROG_LEAGUES_V2_LEAGUE_VIEW';
/** User views one of the screens for the total prizes modal in Progressive Leagues V2 (metadata will say which screen) */
export const PROG_LEAGUES_V2_VIEW_TOTAL_PRIZES_MODAL = 'PROG_LEAGUES_V2_VIEW_TOTAL_PRIZES_MODAL';
/** User views the info modal in Progressive Leagues V2 (metadata will say which screen) */
export const PROG_LEAGUES_V2_VIEW_INFO_MODAL = 'PROG_LEAGUES_V2_VIEW_INFO_MODAL';
/** User views the milestone rewards modal in Progressive Leagues V2 */
export const PROG_LEAGUES_V2_VIEW_MILESTONE_REWARDS_MODAL =
  'PROG_LEAGUES_V2_VIEW_MILESTONE_REWARDS_MODAL';
/** User claims a single milestone reward */
export const PROG_LEAGUES_V2_CLAIM_SINGLE_MILESTONE = 'PROG_LEAGUES_V2_CLAIM_SINGLE_MILESTONE';
/** User claims all milestone rewards */
export const PROG_LEAGUES_V2_CLAIM_ALL_MILESTONES = 'PROG_LEAGUES_V2_CLAIM_ALL_MILESTONES';
/** User taps the info icon in the milestone rewards modal */
export const PROG_LEAGUES_V2_TAP_MILESTONE_REWARDS_INFO =
  'PROG_LEAGUES_V2_TAP_MILESTONE_REWARDS_INFO';

//************************************
// CHAT
//************************************
export const PLAYER_CHAT_CLICK_CHAT_BAR = 'PLAYER_CHAT_CLICK_CHAT_BAR';

//************************************
// SIGN_IN
//************************************
export const SIGN_IN_PHONE_SUCCESS = 'SIGN_IN_PHONE_SUCCESS';
export const SIGN_IN_PHONE_UNRECOGNIZED = 'SIGN_IN_PHONE_UNRECOGNIZED';

//************************************
// CORE LOOP PLAY + VS
//************************************
/** User taps the “Cash” section of the currency bar */
export const CURRENCY_BAR_CASH = 'CURRENCY_BAR_CASH';
/** User taps the “Ticketz” section of the currency bar */
export const CURRENCY_BAR_TICKETZ = 'CURRENCY_BAR_TICKETZ';
/** User taps the “Z” section of the currency bar */
export const CURRENCY_BAR_Z = 'CURRENCY_BAR_Z';
/** User taps the “Chat” icon from the currency bar */
export const CURRENCY_BAR_CHAT = 'CURRENCY_BAR_CHAT';
/** User taps the “Menu” from the footer bar */
export const FOOTER_MENU = 'FOOTER_MENU';
/** Users taps the profile section of the Hamburger Menu */
export const MENU_PROFILE = 'MENU_PROFILE';
/** User opens Chat from the More Menu */
export const MENU_CHAT = 'MENU_CHAT';
/** User opens the Help center from teh More Menu */
export const MENU_HELP_CENTER = 'MENU_HELP_CENTER';
/** User opens the Progression room from the More Menu */
export const MENU_PROGRESSION = 'MENU_PROGRESSION';
/** User opens the Trophies page from the More Menu */
export const MENU_TROPHIES = 'MENU_TROPHIES';
/** User opens the Referrals page from the More Menu */
export const MENU_REFERRALS = 'MENU_REFERRALS';
/** User opens the Skillz News channel from the More Menu */
export const MENU_NEWS = 'MENU_NEWS';
/** User taps to open Support Messages from the More Menu */
export const MENU_SUPPORT_MESSAGES = 'MENU_SUPPORT_MESSAGES';
/** User taps to open Contact Support from the More Menu */
export const MENU_CONTACT_SUPPORT = 'MENU_CONTACT_SUPPORT';
/** A Skillz News banner on the Play Tile is seen fully */
export const SKILLZ_NEWS_VIEW = 'SKILLZ_NEWS_VIEW';
/** User taps the Skillz News banner to trigger the Overlay */
export const SKILLZ_NEWS_BANNER_OVERLAY = 'SKILLZ_NEWS_BANNER_OVERLAY';
/** User swipes between Skillz News messages */
export const SKILLZ_NEWS_SWIPE = 'SKILLZ_NEWS_SWIPE';
/** Skillz News overlay is dismissed */
export const SKILLZ_NEWS_OVERLAY_DISMISS = 'SKILLZ_NEWS_OVERLAY_DISMISS';
/** CTA in the Skillz News overlay is tapped */
export const SKILLZ_NEWS_OVERLAY_CTA = 'SKILLZ_NEWS_OVERLAY_CTA';
/** The “All” filter on the Play Screen is tapped */
export const PLAY_FILTERS_ALL = 'PLAY_FILTERS_ALL';
/** The “Events” filter on the Play Screen is tapped */
export const PLAY_FILTERS_EVENTS = 'PLAY_FILTERS_EVENTS';
/** The “Play Live” filter on the Play Screen is tapped */
export const PLAY_FILTERS_PLAY_LIVE = 'PLAY_FILTERS_PLAY_LIVE';
/** The “Head to Head” filter on the Play Screen is tapped */
export const PLAY_FILTERS_HEAD_TO_HEAD = 'PLAY_FILTERS_HEAD_TO_HEAD';
/** The “VS Friends” filter on the Play Screen is tapped */
export const PLAY_FILTERS_VS_FRIENDS = 'PLAY_FILTERS_VS_FRIENDS';
/** The “Brackets” filter on the Play Screen is tapped */
export const PLAY_FILTERS_BRACKETS = 'PLAY_FILTERS_BRACKETS';
/** User taps the “Match Code” CTA on the Play Screen */
export const PLAY_MATCH_CODE_CTA = 'PLAY_MATCH_CODE_CTA';
/** User taps the “Rules” CTA for a game mode on the Play Screen */
export const PLAY_GAME_MODE_RULES = 'PLAY_GAME_MODE_RULES';
/** User taps the “CTA” on the game mode overlay */
export const PLAY_GAME_MODE_RULES_CTA = 'PLAY_GAME_MODE_RULES_CTA';
/** User taps outside the Rules overlay to dismiss */
export const PLAY_GAME_MODE_RULES_DISMISS = 'PLAY_GAME_MODE_RULES_DISMISS';
/** User taps the Sync entry point on the Play Tab */
export const PLAY_SYNC_ENTRY = 'PLAY_SYNC_ENTRY';
/** User taps the Skillz Branding section of the Play Screen */
export const PLAY_SKILLZ_BRANDING = 'PLAY_SKILLZ_BRANDING';
/** The re-education flow is triggered for a user */
export const CORE_LOOP_EDUCATION_TRIGGER = 'CORE_LOOP_EDUCATION_TRIGGER';
/** User taps “No Thanks” after triggering the re-education flow */
export const CORE_LOOP_EDUCATION_NOTHANKS = 'CORE_LOOP_EDUCATION_NOTHANKS';
/** User taps “Show Me Around” after triggering the re-education flow */
export const CORE_LOOP_EDUCATION_SHOWMEAROUND = 'CORE_LOOP_EDUCATION_SHOWMEAROUND';
/** User taps “Next” on the re-education screen showcasing the new More Menu */
export const CORE_LOOP_EDUCATION_MORENEXT = 'CORE_LOOP_EDUCATION_MORENEXT';
/** User taps “Skip” on the re-education screen showing the new More Menu */
export const CORE_LOOP_EDUCATION_MORESKIP = 'CORE_LOOP_EDUCATION_MORESKIP';
/** User taps “Next” on the re-education screen showing the chat location */
export const CORE_LOOP_EDUCATION_CHATNEXT = 'CORE_LOOP_EDUCATION_CHATNEXT';
/** User taps “Skip” on the re-education screen showing the chat location */
export const CORE_LOOP_EDUCATION_CHATSKIP = 'CORE_LOOP_EDUCATION_CHATSKIP';
/** User taps “Next” on the on the re-education screen showing the filters */
export const CORE_LOOP_EDUCATION_FILTERNEXT = 'CORE_LOOP_EDUCATION_FILTERNEXT';
/** User taps “Skip” on the re-education screen showing the filters */
export const CORE_LOOP_EDUCATION_FILTERSKIP = 'CORE_LOOP_EDUCATION_FILTERSKIP';
/** User taps “Play Now’ to complete the re-education flow */
export const CORE_LOOP_EDUCATION_TEMPLATESPLAY = 'CORE_LOOP_EDUCATION_TEMPLATESPLAY';
/** VS Friend Challenge in the Your Turn carousel on the play screen is tapped */
export const PLAY_YOURTURN_FRIEND_CHALLENGE = 'PLAY_YOURTURN_FRIEND_CHALLENGE';
/** User taps “Submit” in the Contact Us / Support Message Box */
export const CONTACT_US_SUBMIT = 'CONTACT_US_SUBMIT';
/** User taps “Get $15 Bonus Cash Invite Friends” in Store Screen */
export const STORE_REFER_FRIEND = 'STORE_REFER_FRIEND';
/** User taps the right arrow next to “Skillz Rewards” in the Store Screen */
export const STORE_REWARDS_RIGHT_ARROW = 'STORE_REWARDS_RIGHT_ARROW';
/** User taps the reward options being advertised under the Skillz Rewards section in Store Screen */
export const STORE_REWARDS_BOX = 'STORE_REWARDS_BOX';
/** Tiebreaker in the Your Turn carousel on the play screen is tapped */
export const PLAY_YOURTURN_TIEBREAKER = 'PLAY_YOURTURN_TIEBREAKER';
/** Next Bracket Round in the Your Turn carousel on the play screen is tapped */
export const PLAY_YOURTURN_BRACKETS = 'PLAY_YOURTURN_BRACKETS';
/** Rematch in the Your Turn carousel on the play screen is tapped */
export const PLAY_YOURTURN_REMATCH = 'PLAY_YOURTURN_REMATCH';
/** X on the rematch tile in the Your Turn carousel on the play screen is tapped */
export const PLAY_YOURTURN_REMATCH_DENY = 'PLAY_YOURTURN_REMATCH_DENY';
/** Each time the user taps on the Login bonus button on store screen */
export const LOGIN_BONUS_CLAIM = 'LOGIN_BONUS_CLAIM';

// SMS Verification
// https://skillzinc.atlassian.net/wiki/spaces/PDS/pages/1721958422/AWS+Events+for+SMS+Verification
//************************************
//*************** DEPOSIT PATH *******
// These Constants are for when the user is on SMS verification after making a deposit
/**User views the first “Verify Phone Number” screen after they made a deposit. */
export const PHONE_VERIFICATION_DEPOSIT_VIEW = 'PHONE_VERIFICATION_DEPOSIT_VIEW';
/**User closes the “Verify Phone Number” screen by tapping the (X) icon. */
export const PHONE_VERIFICATION_DEPOSIT_EXIT = 'PHONE_VERIFICATION_DEPOSIT_EXIT';
/**Server successfully sends a verification attempt to Twilio. */
export const PHONE_VERIFICATION_DEPOSIT_SEND = 'PHONE_VERIFICATION_DEPOSIT_SEND';
/**Server successfully sends a verification re-attempt to Twilio. */
export const PHONE_VERIFICATION_DEPOSIT_RESEND = 'PHONE_VERIFICATION_DEPOSIT_RESEND';
/**Server successfully verifies the phone number for a user.*/
export const PHONE_VERIFICATION_DEPOSIT_SUCCESS = 'PHONE_VERIFICATION_DEPOSIT_SUCCESS';
//*************** CASH PlAY PATH *******
// These Constants are for when the user is on SMS verification after attempting to play a cash game
/**User views the first “Verify Phone Number” screen before attempting to play a cash game.*/
export const PHONE_VERIFICATION_CASH_PLAY_VIEW = 'PHONE_VERIFICATION_CASH_PLAY_VIEW';
/**User closes the “Verify Phone Number” screen by tapping the (X) icon.*/
export const PHONE_VERIFICATION_CASH_PLAY_EXIT = 'PHONE_VERIFICATION_CASH_PLAY_EXIT';
/**Server successfully sends a verification attempt to Twilio.*/
export const PHONE_VERIFICATION_CASH_PLAY_SEND = 'PHONE_VERIFICATION_CASH_PLAY_SEND';
/**Server successfully sends a verification re-attempt to Twilio.*/
export const PHONE_VERIFICATION_CASH_PLAY_RESEND = 'PHONE_VERIFICATION_CASH_PLAY_RESEND';
/**Server successfully verifies the phone number for a user.*/
export const PHONE_VERIFICATION_CASH_PLAY_SUCCESS = 'PHONE_VERIFICATION_CASH_PLAY_SUCCESS';
//*************** MENU PATH *******
// These Constants are for when the user is on SMS verification from the account menu
/**User views the first “Verify Phone Number” screen from the menu path*/
export const PHONE_VERIFICATION_MENU_VIEW = 'PHONE_VERIFICATION_MENU_VIEW';
/**User closes the “Verify Phone Number” screen by tapping the (X) icon.*/
export const PHONE_VERIFICATION_MENU_EXIT = 'PHONE_VERIFICATION_MENU_EXIT';
/**Server successfully sends a verification attempt to Twilio.*/
export const PHONE_VERIFICATION_MENU_SEND = 'PHONE_VERIFICATION_MENU_SEND';
/**Server successfully sends a verification re-attempt to Twilio.*/
export const PHONE_VERIFICATION_MENU_RESEND = 'PHONE_VERIFICATION_MENU_RESEND';
/**Server successfully verifies the phone number for a user.*/
export const PHONE_VERIFICATION_MENU_SUCCESS = 'PHONE_VERIFICATION_MENU_SUCCESS';
//*************** LEGACY EVENTS *******
// These Constants are for every path into SMS
/**Server successfully/unsuccessfully  verifies the phone number for a user sent with params.*/
export const PLAYER_CHAT_PHONE_VERIFY_SUBMIT_API = 'PLAYER_CHAT_PHONE_VERIFY_SUBMIT_API';
/**Server successfully sends a verification re-attempt to Twilio.*/
export const PLAYER_CHAT_PHONE_VERIFY_RESEND = 'PLAYER_CHAT_PHONE_VERIFY_RESEND';
/**Server successfully sends a verification attempt to Twilio.*/
export const PLAYER_CHAT_PHONE_VERIFY_SEND = 'PLAYER_CHAT_PHONE_VERIFY_SEND';

//************************************
// INSTANT MATCH
//************************************
/** Player sees the instant match drawer */
export const INSTAMATCH_PLAYSCREEN = 'INSTAMATCH_PLAYSCREEN';
/** Player sees the instant match confirmation modal */
export const INSTAMATCH_CONFIRMATION_INTERSTITIAL_VIEW =
  'INSTAMATCH_CONFIRMATION_INTERSTITIAL_VIEW';
/** Player taps the “Play Now” button on the instant match confirmation modal */
export const INSTAMATCH_CONFIRMATION_INTERSTITIAL_ACCEPT =
  'INSTAMATCH_CONFIRMATION_INTERSTITIAL_ACCEPT';
/** Player taps the “Decline” button on the instant match confirmation modal */
export const INSTAMATCH_CONFIRMATION_INTERSTITIAL_DECLINE =
  'INSTAMATCH_CONFIRMATION_INTERSTITIAL_DECLINE';
/**Player sees the instant match tile on the play screen */
export const INSTAMATCH_PLAYSCREEN_TILE = 'INSTAMATCH_PLAYSCREEN_TILE';
/**Player taps on the instant match quick play tile on the play screen */
export const INSTAMATCH_PLAYSCREEN_TILE_TAP = 'INSTAMATCH_PLAYSCREEN_TILE_TAP';
/** User swipes down to exit the instant match drawer */
export const INSTAMATCH_PLAYSCREEN_EXIT = 'INSTAMATCH_PLAYSCREEN_EXIT';
/** The configured time the instant match drawer can be on the play screen before closing/ending */
export const INSTAMATCH_PLAYSCREEN_TIME = 'INSTAMATCH_PLAYSCREEN_TIME';
/** The actual time the instant match drawer was seen on the play screen before a player taps to play */
export const INSTAMATCH_PLAYSCREEN_TIMEUSED = 'INSTAMATCH_PLAYSCREEN_TIMEUSED';
/** The player has not closed the selector and didn’t play the instant match and ran out of time. */
export const INSTAMATCH_PLAYSCREEN_TIMEOUT = 'INSTAMATCH_PLAYSCREEN_TIMEOUT';
/** The number of matches that were displayed to the player on the instant match drawer within the X seconds the drawer was up. */
export const INSTAMATCH_PLAYSCREEN_MATCHES = 'INSTAMATCH_PLAYSCREEN_MATCHES';
/** Triggered after the user has already reached the maximum number of Instant Match discounts per day, but attempts to receive another Instant Match discount */
export const INSTAMATCH_LIMIT_REACHED = 'INSTAMATCH_LIMIT_REACHED';
//************************************

//************************************
// CLUBZ
//************************************
/** On the footer bar a player taps on the icon */
export const CLUBZ_OPEN_TAP = 'CLUBZ_OPEN_TAP';
/** On the Clubz Drawer a player taps to learn more */
export const CLUBZ_DRAWER_LEARNMORE_TAP = 'CLUBZ_DRAWER_LEARNMORE_TAP';
/** On the Clubz Drawer a player dismisses and goes back to play screen */
export const CLUBZ_DRAWER_CLOSE_TAP = 'CLUBZ_DRAWER_CLOSE_TAP';
/** On the Found Club a player taps to open Club Room */
export const CLUBZ_JOINTEAM_TAP = 'CLUBZ_JOINTEAM_TAP';
/** On the Found Club a player dismisses and goes back to play screen */
export const CLUBZ_JOINTEAM_CLOSE_TAP = 'CLUBZ_JOINTEAM_CLOSE_TAP';

//************************************
// Account Merge
//************************************
/** User taps the “Merge Account” button on the Account Merge screen */
export const MERGE_ACCOUNT_MERGE_CLICK = 'MERGE_ACCOUNT_MERGE_CLICK';
/** User taps the non-primary account to make it primary on the Account Merge screen */
export const MERGE_ACCOUNT_USER_SWAP_CLICK = 'MERGE_ACCOUNT_USER_SWAP_CLICK';
/** User views the Account Merge screen */
export const MERGE_ACCOUNT_ON_SHOW = 'MERGE_ACCOUNT_ON_SHOW';
/** Automatically merge guest account on siging in as a existing user */
export const MERGE_ACCOUNT_AUTO_MERGE = 'MERGE_ACCOUNT_AUTO_MERGE';

//************************************
// Push Notifications
//************************************
export const PUSH_SOFT_PROMPT_SHOWN = 'PUSH_SOFT_PROMPT_SHOWN';
export const PUSH_SOFT_PROMPT_ACCEPTED = 'PUSH_SOFT_PROMPT_ACCEPTED';
export const PUSH_SOFT_PROMPT_DENIED = 'PUSH_SOFT_PROMPT_DENIED';
export const PUSH_HARD_PROMPT_SHOWN = 'PUSH_HARD_PROMPT_SHOWN';
export const PUSH_HARD_PROMPT_ACCEPTED = 'PUSH_HARD_PROMPT_ACCEPTED';
export const PUSH_HARD_PROMPT_DENIED = 'PUSH_HARD_PROMPT_DENIED';

//************************************
// Profile
//************************************

export const PROFILE_REFRESH_USERNAME = 'PROFILE_REFRESH_USERNAME';
export const PROFILE_REFRESH_AVATAR = 'PROFILE_REFRESH_AVATAR';
export const PROFILE_CLICK_AVATAR = 'PROFILE_CLICK_AVATAR';

//************************************
// Cash Disabled Location
//************************************

export const CASH_DISABLED_LOCATION_MODAL = 'CASH_DISABLED_LOCATION_MODAL';
export const CASH_DISABLED_LOCATION_MODAL_LEARN_MORE = 'CASH_DISABLED_LOCATION_MODAL_LEARN_MORE';
export const CASH_DISABLED_LOCATION_MODAL_PLAY_NOW = 'CASH_DISABLED_LOCATION_MODAL_PLAY_NOW';
export const CASH_DISABLED_LOCATION_MODAL_DEPOSIT = 'CASH_DISABLED_LOCATION_MODAL_DEPOSIT';
export const CASH_DISABLED_INITIAL_LOCATION_PERMISSION_DENIED =
  'CASH_DISABLED_INITIAL_LOCATION_PERMISSION_DENIED';
export const CASH_DISABLED_INITIAL_LOCATION_PERMISSION_GRANTED =
  'CASH_DISABLED_INITIAL_LOCATION_PERMISSION_GRANTED';
export const CASH_DISABLED_SECOND_CHECK_FAILED = 'CASH_DISABLED_SECOND_CHECK_FAILED';
export const CASH_DISABLED_INITIAL_CHECK_PASSED = 'CASH_DISABLED_INITIAL_CHECK_PASSED';
export const CASH_DISABLED_INITIAL_CHECK_FAILED = 'CASH_DISABLED_INITIAL_CHECK_FAILED';

//************************************
// Account Menu Events
//************************************
export const MENU_ACCOUNT_BALANCE = 'MENU_ACCOUNT_BALANCE';
export const MENU_ACCOUNT_PERSONAL_INFO = 'MENU_ACCOUNT_PERSONAL_INFO';
export const MENU_ACCOUNT_WITHDRAW = 'MENU_ACCOUNT_WITHDRAW';
export const MENU_NOTIFICATIONS = 'MENU_NOTIFICATIONS';
export const MENU_ACCOUNT_SAVE_ACCOUNT = 'MENU_ACCOUNT_SAVE_ACCOUNT';
export const MENU_CHANGE_PASSWORD = 'MENU_CHANGE_PASSWORD';
export const MENU_CHANGE_USERNAME = 'MENU_CHANGE_USERNAME';
export const MENU_ACCOUNT_VERIFY_PHONE = 'MENU_ACCOUNT_VERIFY_PHONE';
export const MENU_ACCOUNT_SAVE_PHONE = 'MENU_ACCOUNT_SAVE_PHONE';

//************************************
// PLOW
//************************************
/** when user taps to share on event details screen or PLOW */
export const SHARE_GAME_PLOW = 'SHARE_GAME_PLOW';

//************************************
// ADVERTISEMENT
//************************************
export const VIDEO_AD_TOURNAMENT_LOAD_FAIL = 'VIDEO_AD_TOURNAMENT_LOAD_FAIL';
export const PLAYER_AD_WITH_REWARD_CLOSE_AD = 'PLAYER_AD_WITH_REWARD_CLOSE_AD';
export const PLAYER_AD_WITHOUT_REWARD_CLOSE_AD = 'PLAYER_AD_WITHOUT_REWARD_CLOSE_AD';
export const PLAYER_AD_REWARD_RECEIVED_NEXT = 'PLAYER_AD_REWARD_RECEIVED_NEXT';
export const PLAYER_AD_REWARD_RECEIVED = 'PLAYER_AD_REWARD_RECEIVED';
export const PLAYER_AD_REQUEST_FROM_TEMPLATE = 'PLAYER_AD_REQUEST_FROM_TEMPLATE';
export const SKILLZ_AD_TERMINATE_FROM_DEEP_LINK = 'SKILLZ_AD_TERMINATE_FROM_DEEP_LINK';

//************************************
// GEOCOMPLY
//************************************
export const GEOCOMPLY_GEOLOCATION_UPDATE_SUCCESS = 'GEOCOMPLY_GEOLOCATION_UPDATE_SUCCESS';
export const GEOCOMPLY_GEOLOCATION_UPDATE_FAILED = 'GEOCOMPLY_GEOLOCATION_UPDATE_FAILED';
export const GEOCOMPLY_ERRORS_LOCATION_PERMISSION = 'GEOCOMPLY_ERRORS_LOCATION_PERMISSION';
export const GEOCOMPLY_ERRORS_PRECISE_LOCATION_PERMISSION =
  'GEOCOMPLY_ERRORS_PRECISE_LOCATION_PERMISSION';
export const GEOCOMPLY_ERRORS_UNEXPECTED = 'GEOCOMPLY_ERRORS_UNEXPECTED';
export const GEOCOMPLY_ERRORS_LICENSE = 'GEOCOMPLY_ERRORS_LICENSE';
export const GEOCOMPLY_GET_PACKET = 'GEOCOMPLY_GET_PACKET';
export const GEOLOCATION_GET_LICENSE = 'GEOLOCATION_GET_LICENSE';
export const GEOCOMPLY_REQUEST_LICENSE = 'GEOCOMPLY_REQUEST_LICENSE';
export const GEOCOMPLY_REQUEST_PACKET = 'GEOCOMPLY_REQUEST_PACKET';
export const GEOCOMPLY_GET_PACKET_TIME_ELAPSED_MS = 'GEOCOMPLY_GET_PACKET_TIME_ELAPSED_MS';

//*************************************
//  LIVE BRACKETS
//*************************************
/** When player sees Live bracket option on home screen */
export const LIVE_BRACKET_TEMPLATE_AVAILABLE = 'LIVE_BRACKET_TEMPLATE_AVAILABLE';
/** When player clicks the LB template from the screen to enter the live bracket screen */
export const LIVE_BRACKET_ICON_HOME_CLICK = 'LIVE_BRACKET_ICON_HOME_CLICK';
/** When player views popup for live bracket */
export const LIVE_BRACKET_BOTTOMSHEET_HOME = 'LIVE_BRACKET_BOTTOMSHEET_HOME';
/** When player clicks on View icon to enter the Live bracket screen */
export const LIVE_BRACKET_BOTTOMSHEET_VIEW_ICON_CLICK = 'LIVE_BRACKET_BOTTOMSHEET_VIEW_ICON_CLICK';
/** When player views registration page */
export const LIVEBRACKETS_REGISTER_VIEW = 'LIVEBRACKETS_REGISTER_VIEW';
/** When player taps to register for a live bracket */
export const LIVEBRACKETS_REGISTER_TAP = 'LIVEBRACKETS_REGISTER_TAP';
/** When player exits registration page */
export const LIVEBRACKETS_REGISTER_EXIT = 'LIVEBRACKETS_REGISTER_EXIT';
/** When player starts the live bracket round */
export const LIVE_BRACKET_GAME_PLAY_BEGIN = 'LIVE_BRACKET_GAME_PLAY_BEGIN';
/** When player clicks on next to complete the live bracket round */
export const LIVE_BRACKET_GAME_PLAY_END = 'LIVE_BRACKET_GAME_PLAY_END';
/** When player clicks on exit to exit the bracket */
export const LIVE_BRACKET_EXIT_ICON_CLICK = 'LIVE_BRACKET_EXIT_ICON_CLICK';
/** When player clicks Ok Button on welcome to Brackets screen */
export const LIVE_BRACKET_WELCOME_SCREEN_CLICK = 'LIVE_BRACKET_WELCOME_SCREEN_CLICK';
/** Location permission check after Register Tap */
export const LIVE_BRACKET_LOCATION_CHECK = 'LIVE_BRACKET_LOCATION_CHECK';
/** When player clicks on Add to calendar after successful Register */
export const LIVE_BRACKET_ADD_CALENDAR_TAP = 'LIVE_BRACKET_ADD_CALENDAR_TAP';
/** Register success/failure event */
export const LIVE_BRACKET_REGISTER_RESULT = 'LIVE_BRACKET_REGISTER_RESULT';
/** Calendar permission check after Add Calendar Tap */
export const LIVE_BRACKET_CALENDAR_PERMISSION_CHECK = 'LIVE_BRACKET_CALENDAR_PERMISSION_CHECK';
/** When player clicks on Notify me Button */
export const LIVE_BRACKET_NOTIFY_CLICK = 'LIVE_BRACKET_NOTIFY_CLICK';
/** Notification/Push notification access check event */
export const LIVE_BRACKET_NOTIFICATION_CHECK = 'LIVE_BRACKET_NOTIFICATION_CHECK';
/** When player clicks on View Bracket button in bottom sheet after nth round */
export const LIVE_BRACKET_BOTTOMSHEET_VIEW_BRACKET_CLICK =
  'LIVE_BRACKET_BOTTOMSHEET_VIEW_BRACKET_CLICK';

//************************************
// INTERSTITIALS
//************************************
export const INTERSTITIAL_SHOWN = 'INTERSTITIAL_SHOWN';
export const INTERSTITIAL_CLOSED = 'INTERSTITIAL_CLOSED';
export const INTERSTITIAL_CLAIMED = 'INTERSTITIAL_CLAIMED';
export const INTERSTITIAL_BANNER_ICON_TAPPED = 'INTERSTITIAL_BANNER_ICON_TAPPED';
export const LTO_INTERSTITIALS_TRIGGERED = 'LTO_INTERSTITIALS_TRIGGERED';
export const LTO_BANNERS_RECEIVED = 'LTO_BANNERS_RECEIVED';

//************************************
// GameOperationsContainer
//************************************
/** when user taps on News button in GameOperationsContainer */
export const GAME_OPERATIONS_CONTAINER_NEWS = 'GAME_OPERATIONS_CONTAINER_NEWS';
/** when user taps on Trophies button in GameOperationsContainer */
export const GAME_OPERATIONS_CONTAINER_TROPHIES = 'GAME_OPERATIONS_CONTAINER_TROPHIES';
/** when user taps on daily rewards V2 button in GameOperationsContainer */
export const GAME_OPERATIONS_CONTAINER_DAILY_REWARDS = 'GAME_OPERATIONS_CONTAINER_DAILY_REWARDS';
/** when user taps on Daily Challenges button in GameOperationsContainer to Claim a prize */
export const GAME_OPERATIONS_CONTAINER_DC_CLAIM = 'GAME_OPERATIONS_CONTAINER_DC_CLAIM';
/** when user taps on Daily Challenges button in GameOperationsContainer to renew a calender from a Expired state */
export const GAME_OPERATIONS_CONTAINER_DC_ASSIGN_FROM_EXPIRED =
  'GAME_OPERATIONS_CONTAINER_DC_ASSIGN_FROM_EXPIRED';
/** when user taps on Daily Challenges button in GameOperationsContainer to renew a calender from a Completed state */
export const GAME_OPERATIONS_CONTAINER_DC_ASSIGN_FROM_COMPLETED =
  'GAME_OPERATIONS_CONTAINER_DC_ASSIGN_FROM_COMPLETED';

//************************************
// SMSVerification
//************************************
export const ACCOUNT_SMS_VERIFY_AREACODE_TAP = 'ACCOUNT_SMS_VERIFY_AREACODE_TAP';
export const ACCOUNT_SMS_VERIFY_SEND = 'ACCOUNT_SMS_VERIFY_SEND';
export const ACCOUNT_SMS_VERIFY_CALL_SEND = 'ACCOUNT_SMS_VERIFY_CALL_SEND';
export const ACCOUNT_SMS_VERIFY_ENTER = 'ACCOUNT_SMS_VERIFY_ENTER';
export const ACCOUNT_SMS_VERIFY_PROMPT = 'ACCOUNT_SMS_VERIFY_PROMPT';

//************************************
// DailyRewardsModal
//************************************
/** Each time the user taps on the Login tab in DailyRewardsModal */
export const DAILY_LOGIN_CLICKED_TAB = 'DAILY_LOGIN_CLICKED_TAB';
/** Each time the user sees the Daily Login / Login Calendar screen in DailyRewardsModal */
export const DAILY_LOGIN_POP_UP_OPEN = 'DAILY_LOGIN_POP_UP_OPEN';
/** When the user closes the DailyRewardsModal while on the Daily Login / Login Calendar screen */
export const DAILY_LOGIN_POP_UP_CLOSED = 'DAILY_LOGIN_POP_UP_CLOSED';
/** Each time the user taps on the Goals tab in DailyRewardsModal */
export const DAILY_CHALLENGE_CLICKED_TAB = 'DAILY_CHALLENGE_CLICKED_TAB';
/** Each time the user sees the Daily Challenge screen in DailyRewardsModal */
export const DAILY_CHALLENGE_POP_UP_OPEN = 'DAILY_CHALLENGE_POP_UP_OPEN';
/** When the user closes the DailyRewardsModal while on the Daily Challenge screen */
export const DAILY_CHALLENGE_POP_UP_CLOSED = 'DAILY_CHALLENGE_POP_UP_CLOSED';
/** When the user first visits the Daily Challenge screen each day the challenges roll over */
export const DAILY_CHALLENGE_STARTED = 'DAILY_CHALLENGE_STARTED';

//************************************
// CHECKOUT FLOW
//************************************
export const CHECKOUT_V2_FAILED_US_ZIP_CHECK_MODAL = 'CHECKOUT_V2_FAILED_US_ZIP_CHECK_MODAL';
export const CHECKOUT_V2_CREDIT_CARD_SUBMIT = 'CHECKOUT_V2_CREDIT_CARD_SUBMIT';
export const CHECKOUT_V2_FAILED_DEPOSIT = 'CHECKOUT_V2_FAILED_DEPOSIT';
export const STORE_DEPOSIT_PAYMENT_TYPE = 'STORE_DEPOSIT_PAYMENT_TYPE';
export const CHECKOUT_V2_APPLEPAY_SAVED = 'CHECKOUT_V2_APPLEPAY_SAVED';
export const CHECKOUT_V2_PAYPAL_SAVED = 'CHECKOUT_V2_PAYPAL_SAVED';
export const CHECKOUT_V2_CREDIT_CARD_SAVED = 'CHECKOUT_V2_CREDIT_CARD_SAVED';
export const CHECKOUT_V2_USE_DIFFERENT_PAYMENT_METHOD = 'CHECKOUT_V2_USE_DIFFERENT_PAYMENT_METHOD';
export const CHECKOUT_DEPOSIT_CONFIRM_CLICK = 'CHECKOUT_DEPOSIT_CONFIRM_CLICK';
export const CHECKOUT_DEPOSIT_SUCCESS = 'CHECKOUT_DEPOSIT_SUCCESS';
export const CHECKOUT_BANK_PROMO_SHOWN = 'CHECKOUT_BANK_PROMO_SHOWN';
export const CHECKOUT_BANK_PROMO_AUTO_SELECTED = 'CHECKOUT_BANK_PROMO_AUTO_SELECTED';
export const CHECKOUT_BANK_PROMO_CLICK = 'CHECKOUT_BANK_PROMO_CLICK';
export const CHECKOUT_BANK_OPTION_CLICK = 'CHECKOUT_BANK_OPTION_CLICK';
export const CHECKOUT_BANK_OPTION_AUTO_SELECTED = 'CHECKOUT_BANK_OPTION_AUTO_SELECTED';
export const CHECKOUT_ADD_METHOD_CLICK = 'CHECKOUT_ADD_METHOD_CLICK';
export const CHECKOUT_USER_DETAIL_CONTINUE_CLICK = 'CHECKOUT_USER_DETAIL_CONTINUE_CLICK';
export const CHECKOUT_BANK_OPTION_DELETE_CLICK = 'CHECKOUT_BANK_OPTION_DELETE_CLICK';
export const CHECKOUT_BANK_DELETE_CONFIRM_CLICK = 'CHECKOUT_BANK_DELETE_CONFIRM_CLICK';
export const CHECKOUT_SAVED_PAYMENT_CLICK = 'CHECKOUT_SAVED_PAYMENT_CLICK';
export const CHECKOUT_V2_DEFAULT_APPLEPAY = 'CHECKOUT_V2_DEFAULT_APPLEPAY';
export const STORE_DEPOSIT_AMOUNT = 'STORE_DEPOSIT_AMOUNT';
export const CHECKOUT_V2_VENMO = 'CHECKOUT_V2_VENMO';
export const CHECKOUT_V2_PAYPAL = 'CHECKOUT_V2_PAYPAL';
export const CHECKOUT_V2_APPLEPAY = 'CHECKOUT_V2_APPLEPAY';
export const CHECKOUT_V2_FRIENDLY_FAILED_MODAL = 'CHECKOUT_V2_FRIENDLY_FAILED_MODAL';
export const CHECKOUT_V2_BANNED_MODAL = 'CHECKOUT_V2_BANNED_MODAL';
export const CHECKOUT_V2_PROMO_BONUS_CASH_INFO_LEARN_MORE =
  'CHECKOUT_V2_PROMO_BONUS_CASH_INFO_LEARN_MORE';
export const CHECKOUT_V2_BONUS_CASH_INFO_LEARN_MORE = 'CHECKOUT_V2_BONUS_CASH_INFO_LEARN_MORE';
export const CHECKOUT_V2_CONTACT_US = 'CHECKOUT_V2_CONTACT_US';
export const CHECKOUT_V2_BONUS_CASH_INFO = 'CHECKOUT_V2_BONUS_CASH_INFO';
export const CHECKOUT_V2_PROMO_BONUS_CASH_INFO = 'CHECKOUT_V2_PROMO_BONUS_CASH_INFO';
export const AEROPAY_AEROSYNC_EVENT = 'AEROPAY_AEROSYNC_EVENT';

//************************************
// TOURNAMENT TEMPLATE CLICK
//************************************
export const TEMPLATE_CLICK = 'TEMPLATE_CLICK';
export const SECTION_TEMPLATE_STATUS = 'SECTION_TEMPLATE_STATUS';
export const SECTION_TEMPLATE_EXPAND_VIEW_CLICK = 'SECTION_TEMPLATE_EXPAND_VIEW_CLICK';
export const MATCH_SELECT_COLLAPSE_SECTION = 'MATCH_SELECT_COLLAPSE_SECTION';
export const MATCH_SELECT_OPEN_SECTION = 'MATCH_SELECT_OPEN_SECTION';

//************************************
// Bonus Cash Milestone1
//************************************
export const FTUE_ACCOUNT_BALANCE_WALLET_VIEW = 'FTUE_ACCOUNT_BALANCE_WALLET_VIEW';
export const FTUE_LOBBY_WALLET_VIEW = 'FTUE_LOBBY_WALLET_VIEW';
export const Z_CASH_CLICK = 'Z_CASH_CLICK';
export const WALLET_BALANCE_ICON_CLICK = 'WALLET_BALANCE_ICON_CLICK';
export const ADD_CASH_CTA_CLICK = 'ADD_CASH_CTA_CLICK';
export const WALLET_TT_TRANSACTIONS_CLICK = 'WALLET_TT_TRANSACTIONS_CLICK';
export const WALLET_TT_WITHDRAW_CLICK = 'WALLET_TT_WITHDRAW_CLICK';

//************************************
// WITHDRAWAL FLOW
//************************************
// Legacy Withdrawal Flow Events
export const WITHDRAWAL_METHOD_CHECK = 'WITHDRAWAL_METHOD_CHECK';
export const WITHDRAWAL_METHOD_PAYPAL = 'WITHDRAWAL_METHOD_PAYPAL';
export const WITHDRAWAL_PAYPAL_EMAIL_CHANGE = 'WITHDRAWAL_PAYPAL_EMAIL_CHANGE';
export const WITHDRAWAL_PROCESSING_FEE_MODAL = 'WITHDRAWAL_PROCESSING_FEE_MODAL';
export const WITHDRAWAL_NEXT = 'WITHDRAWAL_NEXT';
export const WITHDRAWAL_CONFIRM_WITHDRAWAL_MODAL = 'WITHDRAWAL_CONFIRM_WITHDRAWAL_MODAL';
export const WITHDRAWAL_SUCCESS_MODAL = 'WITHDRAWAL_SUCCESS_MODAL';
export const WITHDRAWAL_PAYPAL_WARNING = 'WITHDRAWAL_PAYPAL_WARNING';

//************************************
// Loyalty Program Revamp Events
//************************************
export const MENU_SKILLZ_REWARDZ_CLICK = 'MENU_SKILLZ_REWARDZ_CLICK';
export const CONTACT_VIP_CALL_US_CLICK = 'CONTACT_VIP_CALL_US_CLICK';
/** when user taps VIP Support button in side menu */
export const CONTACT_VIP_ACCOUNT_MANAGER_TAP = 'CONTACT_VIP_ACCOUNT_MANAGER_TAP';
/** when user taps WhatsApp button in VIP account manager modal */
export const VIP_ACCOUNT_MANAGER_MODAL_WHATSAPP_TAP = 'VIP_ACCOUNT_MANAGER_MODAL_WHATSAPP_TAP';
/** when user taps call button in VIP account manager modal */
export const VIP_ACCOUNT_MANAGER_MODAL_CALL_TAP = 'VIP_ACCOUNT_MANAGER_MODAL_CALL_TAP';
/** when user taps email/text button in VIP account manager modal */
export const VIP_ACCOUNT_MANAGER_MODAL_EMAIL_TAP = 'VIP_ACCOUNT_MANAGER_MODAL_EMAIL_TAP';
/** when user taps contact card button in VIP account manager modal */
export const VIP_ACCOUNT_MANAGER_MODAL_CONTACTCARD_TAP =
  'VIP_ACCOUNT_MANAGER_MODAL_CONTACTCARD_TAP';
export const MENU_VIEW_LOYALTY_PROGRESS = 'MENU_VIEW_LOYALTY_PROGRESS';
export const HISTORY_SKILLZ_REWARZ_ICON_CLICK = 'HISTORY_SKILLZ_REWARZ_ICON_CLICK';
export const PROFILE_SKILLZ_REWARZ_ICON_CLICK = 'PROFILE_SKILLZ_REWARZ_ICON_CLICK';
export const SR_MAIN_UI_VIEW = 'SR_MAIN_UI_VIEW';
export const SR_MAIN_UI_CLICK_BACK = 'SR_MAIN_UI_CLICK_BACK';
export const SR_MAIN_UI_SWIPE = 'SR_MAIN_UI_SWIPE';
export const SR_MAIN_UI_FAQ_LINK_CLICK = 'SR_MAIN_UI_FAQ_LINK_CLICK';
export const SR_MAIN_UI_BENEFITS_TOOLTIP_CLICK = 'SR_MAIN_UI_BENEFITS_TOOLTIP_CLICK';
export const SKILLZ_REWARDZ_INFO_VIEW = 'SKILLZ_REWARDZ_INFO_VIEW';
export const SKILLZ_REWARDZ_CONCLUSION_VIEW = 'SKILLZ_REWARDZ_CONCLUSION_VIEW';

//************************************
// Referral Program V2 Events
//************************************
export const REFERRAL_PAGE_VIEW_DETAIL_CLICK = 'REFERRAL_PAGE_VIEW_DETAIL_CLICK';
export const REFERRAL_PAGE_TERMS_AND_CONDITIONS_CLICK = 'REFERRAL_PAGE_TERMS_AND_CONDITIONS_CLICK';
export const REFERRAL_LOBBY_ICON_CLICK = 'lobby_icon_click';

//************************************
// WITHDRAWAL FLOW
//************************************
export const WITHDRAWAL_OPTIONS_SCREEN_SHOWN = 'WITHDRAWAL_OPTIONS_SCREEN_SHOWN';
export const WITHDRAWAL_OPTIONS_SCREEN_CLICK = 'WITHDRAWAL_OPTIONS_SCREEN_CLICK';
export const WITHDRAWAL_LINK_BANK_POPUP_SHOWN = 'WITHDRAWAL_LINK_BANK_POPUP_SHOWN';
export const WITHDRAWAL_LINK_BANK_POPUP_CLICK = 'WITHDRAWAL_LINK_BANK_POPUP_CLICK';
export const WITHDRAWAL_ADD_NEW_BANK_CLICK = 'WITHDRAWAL_ADD_NEW_BANK_CLICK';
export const WITHDRAWAL_CONFIRMATION_MODAL_CLICK = 'WITHDRAWAL_CONFIRMATION_MODAL_CLICK';
export const WITHDRAWAL_BANK_PHONE_VERIFICATION = 'WITHDRAWAL_BANK_PHONE_VERIFICATION';
export const WITHDRAWAL_BANK_NAVIGATOR_OPTION_CLICK = 'WITHDRAWAL_BANK_NAVIGATOR_OPTION_CLICK';
/** result screen revamped events */
export const NEW_RESULT_SCREEN_SHOWN = 'NEW_RESULT_SCREEN_SHOWN';
export const NEW_RESULT_SCREEN_PLAY_AGAIN_CLICKED = 'NEW_RESULT_SCREEN_PLAY_AGAIN_CLICKED';
export const NEW_RESULT_SCREEN_PLAY_TIE_BREAKER_CLICKED =
  'NEW_RESULT_SCREEN_PLAY_TIE_BREAKER_CLICKED';
export const NEW_RESULT_SCREEN_REMATCH_CLICKED = 'NEW_RESULT_SCREEN_REMATCH_CLICKED';
export const NEW_RESULT_SCREEN_WATCH_REPLAY_CLICKED = 'NEW_RESULT_SCREEN_WATCH_REPLAY_CLICKED';
export const NEW_RESULT_SCREEN_SHARE_CLICKED = 'NEW_RESULT_SCREEN_SHARE_CLICKED';
export const NEW_RESULT_SCREEN_EXIT_CLICKED = 'NEW_RESULT_SCREEN_EXIT_CLICKED';
export const NEW_RESULT_SCREEN_COPY_MATCH_ID = 'NEW_RESULT_SCREEN_COPY_MATCH_ID';
export const NEW_RESULT_SCREEN_AVATAR_CLICKED = 'NEW_RESULT_SCREEN_AVATAR_CLICKED';
export const RESULT_SCREEN_RECOMMENDED_TOURNAMENT_CLICKED =
  'RESULT_SCREEN_RECOMMENDED_TOURNAMENT_CLICKED';
export const NEW_RESULT_SCREEN_ADD_BALANCE_CLICKED = 'NEW_RESULT_SCREEN_ADD_BALANCE_CLICKED';

/** Revamped Store Page events */
export const STORE_V2_CAROUSEL_CLICK = 'STORE_V2_CAROUSEL_CLICK';
export const STORE_V2_DEPOSIT_TILE_CLICK = 'STORE_V2_DEPOSIT_TILE_CLICK';
export const STORE_V2_PROMO_COUPON_CLICK = 'STORE_V2_PROMO_COUPON_CLICK';
export const STORE_V2_DEP_SUCC_DISC_TPL_CLICK = 'STORE_V2_DEP_SUCC_DISC_TPL_CLICK';
export const STORE_V2_DEP_SUCC_RECO_TPL_CLICK = 'STORE_V2_DEP_SUCC_RECO_TPL_CLICK';
export const STORE_V2_DEP_SUCC_DISC_TPL_SEEN = 'STORE_V2_DEP_SUCC_DISC_TPL_SEEN';
export const STORE_V2_DEP_SUCC_RECO_TPL_SEEN = 'STORE_V2_DEP_SUCC_RECO_TPL_SEEN';
// Daily LTO events
export const DAILY_BONUS_LTO_CALENDAR_VIEWED = 'daily_bonus_lto_calendar_viewed';
export const DAILY_BONUS_LTO_CALENDAR_CLCIKED = 'daily_bonus_lto_calendar_clicked';

//************************************
// FTUE 2.0 Events
//************************************
export const NFTUE_TNCS_POPUP_SEEN = 'ftue_tncs_popup_seen';
export const NFTUE_TNCS_POPUP_CLICKED = 'nftue_tncs_popup_clicked';
export const NFTUE_UNIFIED_LOGIN_CTA_CLICKED = 'nftue_unified_login_cta_clicked';
export const NFTUE_MOBILE_SIGNIN_CTA_CLICKED = 'nftue_mobile_signin_cta_clicked';
export const NFTUE_OTP_PAGE_CTA_CLICKED = 'nftue_otp_page_cta_clicked';
export const NFTUE_EMAIL_PAGE_CTA_CLICKED = 'nftue_email_page_cta_clicked';
